module.exports = __webpack_public_path__ + "static/media/ic_compass.c86ed9bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/ic_compass.svg
// module id = 389
// module chunks = 0